var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeadphones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.285 8.344C3.701 8.50142 3.18515 8.84693 2.81729 9.32705C2.44942 9.80717 2.25004 10.3952 2.25 11V14C2.25 14.7293 2.53973 15.4288 3.05546 15.9445C3.57118 16.4603 4.27065 16.75 5 16.75H7.5C7.69891 16.75 7.88968 16.671 8.03033 16.5303C8.17098 16.3897 8.25 16.1989 8.25 16V9C8.25 8.80109 8.17098 8.61032 8.03033 8.46967C7.88968 8.32902 7.69891 8.25 7.5 8.25H5.815C6.244 5.78 8.759 3.75 12 3.75C15.241 3.75 17.756 5.78 18.185 8.25H16.5C16.3011 8.25 16.1103 8.32902 15.9697 8.46967C15.829 8.61032 15.75 8.80109 15.75 9V16C15.75 16.414 16.086 16.75 16.5 16.75H18.163C17.994 17.4618 17.5898 18.0958 17.0158 18.5495C16.4419 19.0032 15.7316 19.25 15 19.25H13.855C13.6809 18.8197 13.3627 18.4634 12.9547 18.2421C12.5467 18.0207 12.0745 17.9482 11.6189 18.0368C11.1633 18.1255 10.7528 18.3698 10.4576 18.728C10.1624 19.0862 10.001 19.5359 10.001 20C10.001 20.4641 10.1624 20.9138 10.4576 21.272C10.7528 21.6302 11.1633 21.8745 11.6189 21.9632C12.0745 22.0518 12.5467 21.9793 12.9547 21.7579C13.3627 21.5366 13.6809 21.1803 13.855 20.75H15C17.4 20.75 19.384 18.97 19.705 16.659C20.2914 16.5033 20.8098 16.1582 21.1797 15.6773C21.5495 15.1964 21.75 14.6067 21.75 14V11C21.75 10.3952 21.5506 9.80717 21.1827 9.32705C20.8148 8.84693 20.299 8.50142 19.715 8.344C19.333 4.84 15.926 2.25 12 2.25C8.074 2.25 4.667 4.84 4.285 8.344Z",
    fill: "url(#paint0_linear_227_2716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_227_2716",
    x1: 12,
    y1: 2.25,
    x2: 12,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#982815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.4aafe45a3939e6fd7b922435f775c393.svg";
export { ForwardRef as ReactComponent };